import { Camera } from 'lucide-react'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

function root({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge('relative mx-auto mb-12 flex w-fit', className)}
      {...rest}
    />
  )
}

function label({ className, ...rest }: ComponentProps<'label'>) {
  return (
    <label
      className={twMerge(
        'absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4',
        className,
      )}
      {...rest}
    />
  )
}

function camera({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge(
        'size-10 cursor-pointer content-center rounded-lg bg-bios-secondary 2xl:size-14',
        className,
      )}
      {...rest}
    >
      <Camera className="mx-auto text-white" />
    </div>
  )
}

export const PhotoProfile = {
  Root: root,
  Label: label,
  Camera: camera,
}
